var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h20v20H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    fillRule: "nonzero",
    d: "M10.27 8.024c.021 2.286 2.005 3.046 2.028 3.056-.017.054-.318 1.084-1.045 2.148-.63.92-1.283 1.836-2.312 1.856-1.012.018-1.338-.6-2.493-.6-1.156 0-1.518.58-2.475.618-.994.038-1.75-.995-2.384-1.911C.292 11.316-.7 7.89.632 5.58c.66-1.147 1.842-1.873 3.125-1.892.975-.02 1.896.655 2.492.655.596 0 1.715-.81 2.89-.692.494.021 1.876.2 2.764 1.499-.072.044-1.65.962-1.633 2.873zm-1.9-5.612c-.528.638-1.393 1.135-2.24 1.069-.116-.867.312-1.771.8-2.336C7.476.506 8.395.03 9.155 0c.098.885-.258 1.773-.786 2.412z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.4f3729a69a219d2fe524e2b4a3a0e041.svg";
export { ForwardRef as ReactComponent };